import styled from 'styled-components';

interface BorderContainerProps {
  hideBorderTop?: boolean;
  hideBorders?: boolean;
  noPaddingBottom?: boolean;
  noPaddingTop?: boolean;
}

const BorderContainer = styled.div<BorderContainerProps>`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    ${({ hideBorderTop = false, hideBorders = false, theme }) =>
      hideBorderTop || hideBorders
        ? null
        : `border-top: 1px solid ${theme.colors.gray.light};`};
    ${({ hideBorders = false, theme }) =>
      !hideBorders && `border-bottom: 1px solid ${theme.colors.gray.light};`};

    ${({ theme, noPaddingTop }) =>
      noPaddingTop ? null : `padding-top: ${theme.spacing[16]}`};
    ${({ theme, noPaddingBottom }) =>
      noPaddingBottom ? null : `padding-bottom: ${theme.spacing[16]}`};
  }
`;

export default BorderContainer;
